import React from 'react';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import AppSchw from './AppSchw';

function Home () {
    return (
        <BrowserRouter>
            <Switch>
                <Route path='/stax/p/stax/' exact={true} component={AppSchw}/>
                <Route path='*' component={AppSchw}/>
            </Switch>
        </BrowserRouter>
    );
}

export default Home;
